import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getUrlParams, getGoqiiUserId } from "../apiService/timespam";
import { lifestyleApi } from "../apiService/api";
import "./Theme.css";
import "./BsaDetails.css";

const getDifficultyLevel = (s) => {
  if (s > 0 && s <= 15) return { text: "Mild", color: "#888" };
  if (s >= 16 && s <= 39) return { text: "Moderate", color: "#4098e3" };
  if (s >= 40) return { text: "Severe", color: "#f3d53a" };
  return { text: "", color: "" };
};

const BsaDetails = () => {
  const { t } = useTranslation();
  const { theme, lang } = getUrlParams();
  const urlParams = new URLSearchParams(window.location.search);
  const uuid = urlParams.get("uuid") || "";
  const goqiiUserId = getGoqiiUserId();
  const nonce = urlParams.get("nonce") || "";
  const apiKey = urlParams.get("apiKey") || "";
  const signature = urlParams.get("signature") || "";
  const goqiiAccessToken = urlParams.get("goqiiAccessToken") || "";
  const type = urlParams.get("type") || "";

  const [score, setScore] = useState(null);
  const [reportUrl, setReportUrl] = useState("");
  const [pfizerUser, setPfizerUser] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.documentElement.className = theme === "dark" ? "dark" : "";
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [theme, lang]);

  useEffect(() => {
    lifestyleApi
      .fetchBsaScore()
      .then((res) => {
        const data = res?.data?.data;
        if (data) {
          setScore(data.score);
          setReportUrl(data.reportUrl || "");
          setPfizerUser(data.pfizerUser || false);
        }
      })
      .catch((err) => console.error("fetchBsaScore:", err))
      .finally(() => setLoading(false));
  }, [type]);

  const buildQs = () =>
    `uuid=${uuid}&goqiiuserid=${goqiiUserId}&nonce=${nonce}&apiKey=${apiKey}&signature=${signature}&goqiiAccessToken=${goqiiAccessToken}&theme=${theme}&lang=${lang}`;

  const difficulty = score != null ? getDifficultyLevel(score) : { text: "", color: "" };

  const viewAllHref = pfizerUser
    ? `https://goqii.com/app?fsn=242&fssn=3&fai=${encodeURIComponent(JSON.stringify({ url: `https://lifestyle1.goqii.com/selfstatspfizer?uuid=${uuid}`, title: "Flareup" }))}`
    : `https://goqii.com/app?fsn=242&fssn=5&fai=${encodeURIComponent(JSON.stringify({ url: `https://lifestyle1.goqii.com/selfstatspfizer?uuid=${uuid}`, title: "Flareup" }))}`;

  return (
    <>
      <section className="bsa-page">
        <div className="bsa-container">
          {loading ? (
            <div className="bsa-loading">{t("common.loading", "Loading...")}</div>
          ) : (
            <>
              <p className="bsa-description">
                {t("bsaDetails.description", "Body surface area (BSA) is a measure of the extent of Psoriasis.")}
              </p>

              {!type && (
                <div className="bsa-take-btn-wrap">
                  <button
                    type="button"
                    className="bsa-take-btn"
                    onClick={() => { window.location.href = `/body-surface-area?${buildQs()}`; }}
                  >
                    {t("bsaDetails.takeBtn", "TAKE A BSA%")}
                  </button>
                </div>
              )}

              {score != null && (
                <>
                  <div className="bsa-question-block">
                    <label className="bsa-label">
                      {type ? t("bsaDetails.currentLabel", "BSA%") : t("bsaDetails.previousLabel", "Previous BSA%")}
                    </label>
                    <div className="bsa-score-row">
                      <span className="bsa-score-value">{score}%</span>
                      {reportUrl ? (
                        <a
                          href={`https://goqii.com/app?fsn=244&fssn=0&fai=${encodeURIComponent(JSON.stringify({ url: reportUrl, title: "BSA-Report" }))}`}
                          className="bsa-report-link"
                        >
                          {t("bsaDetails.viewReport", "View Report")}
                        </a>
                      ) : null}
                    </div>
                  </div>

                  <div className="bsa-view-all-wrap">
                    <a href={viewAllHref} className="bsa-view-all-link">
                      {t("bsaDetails.viewAll", "View All Previous BSA%")}
                    </a>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default BsaDetails;
